import useRequestImmutable from './useRequestImmutable';
import { isRealworldAdminRole } from '@/utils/roleAccess';

export default function useIsAdminSelector() {
  const { data, ...rest } = useRequestImmutable<MyInfo>('/api/me');

  return {
    data: isRealworldAdminRole(data?.role),
    ...rest
  };
}
